import { ProductBatchTypeEnum } from "@c2b/muven-commons";
import { ProductBatchItemPricePercentagePayloadModel } from "./ProductBatchItemPricePercentagePayloadModel";
import { ProductBatchItemPriceValuePayloadModel } from "./ProductBatchItemPriceValuePayloadModel";
import { ProductBatchItemProductModel } from "./ProductBatchItemProductModel";

export class ProductBatchItemModel {
    id: number;
    batchType: ProductBatchTypeEnum;
    product: ProductBatchItemProductModel;
    isBeingModified: boolean = false;
    payload: {
        [key: string]: any;
    } = {};

    constructor(it: Partial<ProductBatchItemModel>, batchType: ProductBatchTypeEnum) {
        Object.assign(this, it)
        this.batchType = batchType
        
        this._parseProduct()
        this._parsePayload()
    }

    setBeingModifiedStatus(st: boolean):void {
        this.isBeingModified = st;
    }

    private _parseProduct():void {
        this.product = new ProductBatchItemProductModel(this.product, this.batchType)
    }

    private _parsePayload():void {
        switch (this.batchType) {
            case ProductBatchTypeEnum.UpdateChannelPriceValue:
                this.payload = new ProductBatchItemPriceValuePayloadModel(this.payload)
                return

            case ProductBatchTypeEnum.UpdateChannelPricePercentage:
                this.payload = new ProductBatchItemPricePercentagePayloadModel(this.payload)
                return
        }
    }
}
